<template>
  <div class="syn_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font">组织架构</span>
      </header>
      <div class="title_line"></div>
      <body>
        <div class="ql-editor" v-html="htmlInfo"></div>
      </body>
    </div>
  </div>
</template>

<script>
import { getFirstcfg } from "@/network/api";
export default {
  data() {
    return {
      synImg: require("@/assets/images/syn_icon.jpg"),
      iconHeader: require("@/assets/images/pageico_1.png"),
      htmlInfo: "",
    };
  },
  mounted() {
    let formData = new FormData();
    formData.append("dpCode", "DP03");
    getFirstcfg(formData).then((res) => {
      if (res.code == 200) {
        this.htmlInfo = res.data.stContent;
      }
    });
  },
};
</script>


<style scoped>
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
.syn_bg {
  display: flex;
  justify-content: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/OrgChart.vue